module.exports = __webpack_public_path__ + "img/com12.8cb1010f.gif";